/**
 * How a generated picture was made (spec 027): the model and the brief, from `GET /media/:id`'s provenance. Shown in the media
 * preview.
 */
import React, { useEffect, useState } from 'react';
import type { ImageProvenanceView } from '../../../../Shared/src/images';
import { apiClient } from '../../api/client';

export const GeneratedDetails: React.FC<{ mediaId: number }> = ({ mediaId }) => {
  const [prov, setProv] = useState<ImageProvenanceView | null>(null);
  useEffect(() => {
    let cancelled = false;
    void apiClient.getMediaById(mediaId).then((res) => {
      if (!cancelled && res.success && res.data?.provenance) setProv(res.data.provenance as ImageProvenanceView);
    }).catch(() => undefined);
    return () => { cancelled = true; };
  }, [mediaId]);
  if (!prov) return null;
  return (
    <div className="mt-2 text-start small" data-testid="media-provenance">
      <div><strong>Generated</strong> · {prov.model}</div>
      {prov.layers?.brief && <div className="text-muted">Brief: {prov.layers.brief}</div>}
    </div>
  );
};

export default GeneratedDetails;
